import React from 'react';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

import { BlockTestInfoSection, Description, SubjectCard } from 'components';

import { useSubjects } from '../hooks';

export const Main = () => {
  const t = useTranslations();
  const { subjects } = useSubjects();

  return (
    <div className="mt-6">
      <div className="space-y-6">
        <h1 className="text-center text-2xl font-semibold uppercase">{t('milliy_sertifikat')}</h1>
        <BlockTestInfoSection title={t('milliy_sertifikat_haqida_toliq_malumot')} href="#info" />
      </div>
      <div className="mb-13 mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
        {subjects?.subjects?.map(subject => (
          <SubjectCard
            url={`${globalConst.pageNames.NATIONAL_CERTIFICATE}/${subject?.slug}`}
            key={subject?.id}
            image={subject?.image}
            title={subject?.name}
            testCount={subject?.tests_count}
          />
        ))}
      </div>
      <Description description={subjects?.description} text={t('milliy_sertifikat_haqida_toliq_malumot')} />
    </div>
  );
};
